import { useURLHash } from "./lib/useURLHash"
import { route } from "./route"

import ThemeProvider from "@mui/material/styles/ThemeProvider"
import createTheme from "@mui/material/styles/createTheme"
import "preact/debug" // https://preactjs.com/guide/v10/debugging/

const theme = createTheme({
  typography: {
    fontFamily: ["Noto Sans", "Verdana", "sans-serif"].join(","),
  },
})

export function App(): JSX.Element {
  const [hash, navigateTo] = useURLHash(window)

  return <ThemeProvider theme={theme}>{route(hash, navigateTo)}</ThemeProvider>
}
